import uniq from 'lodash/uniq';

const hasCommon = (arr1, arr2) => {
  return arr2.every(item => arr1.includes(item));
};

export const compileFilters = () => {
  const allItems = window.INSIGHTS;

  return allItems.reduce(
    (acc, current) => {
      return {
        topics: uniq([...acc.topics, ...current.topics]),
        industry: uniq([...acc.industry, ...current.industry]),
        technology: uniq([...acc.technology, ...current.technology])
      };
    },
    {
      topics: [],
      industry: [],
      technology: []
    }
  );
};

const updateSelectedFilters = (e, selected) => {
  if (!e || !e.target) return selected;
  const { checked, value, name } = e.target;
  let filter = selected[name];
  if (checked) {
    filter.push(value);
  } else {
    filter = filter.filter(x => x !== value);
  }

  return {
    ...selected,
    [name]: filter
  };
};

const filterItems = (items, selected) => {
  const filtered = items.filter(x => {
    const hasTopics = selected.topics.length
      ? hasCommon(x.topics, selected.topics)
      : true;
    const hasIndustry = selected.industry.length
      ? hasCommon(x.industry, selected.industry)
      : true;
    const hasTechnology = selected.technology.length
      ? hasCommon(x.technology, selected.technology)
      : true;

    return hasTopics && hasIndustry && hasTechnology;
  });

  return filtered;
};

export const getCounts = (filters, items) => {
  return Object.entries(filters).reduce((acc, [category, tags]) => {
    if (!acc[category]) {
      acc[category] = {};
    }

    tags.forEach(tag => {
      if (!acc[category][tag]) {
        acc[category][tag] = 0;
      }

      acc[category][tag] += items.filter(item =>
        item[category].includes(tag)
      ).length;
    });

    return acc;
  }, {});
};

const getFilteredItemsWithCount = (selected, all) => {
  const filteredItems = filterItems(window.INSIGHTS, selected);

  return {
    count: getCounts(all, filteredItems),
    items: filteredItems
  };
};

export const filter = (e, filters, selected) => {
  const newlySelectedFilters = updateSelectedFilters(e, selected);
  const data = getFilteredItemsWithCount(newlySelectedFilters, filters);

  return { selected: newlySelectedFilters, ...data };
};
